import React, { Component } from 'react';
import {
    Col,
    Row
} from "reactstrap";

import TYCard from "../components/TYCard";
import Registry from "../Utils/Registry";
import Helpers from "../Utils/Helpers";

import AnalyticsChartConsumption from "../components/Analytics/Charts/Consumption";
import AnalyticsEcoPeriodCard from "../components/Analytics/EcoPeriodCard";
import HomeOrders from "../components/Home/Orders";


class Home extends Component {
    constructor(props) {
        super(props);

        this.api = Registry.registered("api");
        this.gas_list = {};
        this.state = {
            user: {business_id: null},
            dropdownOpen: false,
            global_stats: {
                gas_delivered: [],
                euro_eco: 0,
                co2_eco: 0
            },
            loading_global: false
        };
    }

    componentDidMount(){
        this.getGasListAndStats();
        Registry.observe(this, "user", user => this.setState({ user: user }));
    }

    toggle = () => this.setState({ dropdownOpen: !this.state.dropdownOpen });

    getGasListAndStats = () => this.api.get("/gas")
        .then(results => {
            this.gas_list = [];
            for(let g of results.gas)
                this.gas_list[g.shorten] = g;
            this.getStats();
        });

    getStats = () => {
        this.setState({loading_global: true});

        this.api.get("/stats/customers?is_business=1&period=month")
            .then(results => {
                let euro_eco = 0;
                let co2_eco = 0;
                let delivered = {};
                for(let r of results.data){
                    if(this.gas_list[r.gas_shorten]){
						if(!delivered[r.gas_shorten]){
							delivered[r.gas_shorten] = {
								shorten: r.gas_shorten,
								name: this.gas_list[r.gas_shorten].name || "",
								color: this.gas_list[r.gas_shorten].color || "",
                                unit: this.gas_list[r.gas_shorten].unit || "L",
								qty: 0
							};
						}
						delivered[r.gas_shorten].qty += r.total_quantity_delivered;
                    }
                    euro_eco += r.euro_eco;
                    co2_eco += r.co2_eco;
                }

                let del_array = Object.values(delivered);
                del_array.sort((a, b) => {
                    if(a.qty < b.qty)
                        return 1;
                    else  if(a.qty > b.qty)
                        return -1;
                    return 0;
                });

                this.setState({
                    global_stats: {
                        gas_delivered: del_array.slice(0, 2),
                        euro_eco: euro_eco,
                        co2_eco: co2_eco
                    },
                    loading_global: false
                });
            })
            .catch(() => this.setState({loading_global: false}));
    }

    render() {
        return (
            <div>
                <Row>
                    <Col xs="12">
                        <h2 className="ty-subtitle">Général</h2>
                    </Col>
                    {
                        this.state.global_stats.gas_delivered.map((g, i) => <Col key={i} xs="12" sm="3" xl="3">
                            <TYCard 
                                value={g.name} 
                                is-loading={this.state.loading_global} 
                                title={Helpers.formatNumeralInt(g.qty) + ` ${g.unit}`} 
                                subtitle="Consommés" 
                            />
                        </Col>)
                    }
                    <Col xs="12" sm="3" xl="3">
                        <TYCard 
                            value="&euro;" 
                            is-loading={this.state.loading_global} 
                            value-size="30" 
                            title={Helpers.formatNumeralInt(this.state.global_stats.euro_eco) + " €"} 
                            subtitle="Economisés" 
                        />
                    </Col>
                    <Col xs="12" sm="3" xl="3">
                        <TYCard 
                            value="CO2" 
                            is-loading={this.state.loading_global} 
                            value-size="20" 
                            title={Helpers.format_co2_eco(this.state.global_stats.co2_eco.toFixed(2), true)} 
                            subtitle="Gagnés" 
                        />
                    </Col>
                </Row>

                <Row>
                    <Col xs="12" sm="12" xl="7">
                        <HomeOrders/>
                    </Col>

                    <Col xs="12" sm="12" xl="5">
                        <Row>
                            <Col xs="12" sm="7" xl="12">
                                <h2 className="ty-subtitle">Ma consommation</h2>
                                <AnalyticsChartConsumption />
                            </Col>

                            <Col xs="12" sm="5" xl="12">
                                <h2 className="ty-subtitle">Mes economies</h2>
                                <AnalyticsEcoPeriodCard type="co2" />
                                <AnalyticsEcoPeriodCard type="euro" />
                                <AnalyticsEcoPeriodCard type="time" />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }

}

export default Home;



// WEBPACK FOOTER //
// ./src/views/Home.js